import { NewMap } from "@synergy/maps";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useAuthContext } from "../../contexts/AuthContext";
import { useGlobalFilterContext } from "../../contexts/GlobalFilterProvider";
import logger from "../../server/server";
import { PageContent } from "../../styles/global/Pages.styled";
import { REACT_APP_MAPS_API_KEY, websocketPort } from "../../utils/config/configs";
import { io } from "socket.io-client";

const socket = io(websocketPort);

export const Map = ({ headerheight }) => {
  const { t } = useTranslation();
  const [mapConfigurations, setMapConfigurations] = useState(null);
  const [selectedPOI, setSelectedPOI] = useState(null);
  const [selectedCluster, setSelectedCluster] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const { user, tenant } = useAuthContext();

  const [selectedFloor, setSelectedFloor] = useState(null);

  const { entity, subEntity, isToApplyFilters,
    mapItemsIncidentsData, isFetchingMapIncidentsData,
    selectedLayer, setSelectedLayer, copyMapPois, setCopyMapPois, refetchMapItemsIncidents
  } = useGlobalFilterContext();

  // useEffect(() => {
  //   if (mapItemsIncidentsData && (subEntity || entity)) {
  //     const configurationsCopy = {
  //       ...defaultMapConfigurations,
  //       lat: Number(subEntity?.latitude ?? entity?.latitude),//38.71956666763748
  //       lng: Number(subEntity?.longitude ?? entity?.longitude),//-9.137763909977604
  //       zoom: subEntity?.zoom === 0 ? null : subEntity?.zoom
  //     };
  //     setMapConfigurations(configurationsCopy);
  //   }
  // }, [mapItemsIncidentsData]);

  useEffect(() => {
    if (selectedPOI) {
      showDrawer();
      setTransitioning(false); // Finaliza a transição
    }
  }, [selectedPOI]);

  useEffect(() => {
    socket.on("manageIncident", (text) => {
      let incs = JSON.parse(text);
      console.log('Novo incidente', incs);
      refetchMapItemsIncidents();
    });
  }, [])

  // const handleMarkerClick = (markerId, event) => {
  //   try {
  //     const clickedMarker = copyMapPois?.find(
  //       (marker) => marker.id === markerId
  //     );
  //     // if (clickedMarker?.label === "Item") {
  //     setTransitioning(true);
  //     setSelectedPOI(clickedMarker);

  //     // Calcula origem do clique no mapa
  //     if (event) {
  //       const boundingRect = event.target.getBoundingClientRect();
  //       const x = event.clientX - boundingRect.left;
  //       const y = event.clientY - boundingRect.top;

  //       setTransitionOrigin(`${(x / boundingRect.width) * 100}% ${(y / boundingRect.height) * 100}%`);
  //     } else {
  //       setTransitionOrigin("50% 50%"); // Centraliza na visão 3D
  //     }
  //   } catch (error) {
  //     console.error("(MapComponent page) Error in handling Marker Click:", error);
  //     logger.error("(MapComponent page) User : " + user?.Username + " Tenant: " + tenant + ", Error in handling Marker Click: ", error);
  //   }
  // };

  const showDrawer = () => {
    setOpenDrawer(true);
    logger.info('User: ' + user?.Username + ' Tenant: ' + tenant + ', Drawer opened!')
  };

  // const onCloseDrawer = () => {
  //   setOpenDrawer(false);
  //   setSelectedPOI(null);
  //   logger.info('User: ' + user?.Username + ' Tenant: ' + tenant + ', Drawer closed!')
  // };

  // const redirectToDigitalTwin = (value) => {
  //   if (value.id) {
  //     window.location.href = `/registry/item/${value.id}/overview/Digital Twin`;
  //   };
  // };

  /**
   * Serializes an array of POIs (Points of Interest) for the map.
   * Used just for layer 'Incidents'.
   *
   * @param {Array} pois - The array of POIs to be serialized.
   * @returns {Array} - The serialized array of POIs with additional properties.
   */
  // const serializePoisForMap = (pois) => {
  //   return pois.map(item => {
  //     return {
  //       ...item,
  //       iconColor: getColorByPriority(item.priority),
  //       bgPadding: '2px',
  //       impactedFAFieldName: t('Impacted FA'),
  //       lastUpdateFieldName: t('Last Update'),
  //       nameFieldName: t('Issue Number'),
  //       serviceNameFieldName: t('Location Name'),
  //     }
  //   }
  //   );
  // };

  // const addNewIncidentToMap = (incident) => {
  //   if (!incident) return;
  //   setCopyMapPois((prevPOIs) => [...prevPOIs, incident]);
  // };

  return (
    <PageContent style={{ height: "100%", overflow: 'hidden' }}>
      <MapWrapper>
        {/* {mapConfigurations && copyMapPois && !isFetchingMapIncidentsData ? ( */}
          <>
            {/* <SpinnerMap id="spinnerMap" className={isFetchingMapIncidentsData ? 'is-loading' : ''}><Spinner stroke="green-4" size='72px' /></SpinnerMap> */}

            <MapContainer>
              <NewMap
                apiKey={REACT_APP_MAPS_API_KEY}
                configurations={defaultMapConfigurations}
                pois={copyMapPois}
                // onMarkerClick={(id, event) => handleMarkerClick(id, event)}
                // onRightClickFucntion={selectedLayer === 'Services' ?
                //   {
                //     // "inPOI": [
                //     //   {
                //     //     label: t("button.create_incident"),
                //     //     function: (value) => setRigthClickCoordinates(value),
                //     //   }
                //     // ],
                //     // "inmap": [
                //     //   {
                //     //     label: t("button.create_incident"),
                //     //     function: (value) => setRigthClickCoordinates(value),
                //     //   }
                //     // ]
                //   } : null}
                // onMapClickFunction={isOnCreateIncidentMode ? (coordenates) => { setMapClickCoordinates(coordenates) } : null}
                // onClusterClick={(cluster) => { setSelectedCluster(cluster); showDrawer(); }}
                // isSvgIcons={selectedLayer === 'Incidents' ? true : false}
              />
            </MapContainer>
          </>
        {/* ) : (
          <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <Spinner stroke="green-4" />
          </div>
        )} */}
      </MapWrapper>

      {/* <MapDrawer
        handle3DView={handle3DView}
        onCloseDrawer={onCloseDrawer}
        openDrawer={openDrawer}
        selectedCluster={selectedCluster}
        selectedLayer={selectedLayer}
        selectedPOI={selectedPOI}
        setSelectedPOI={setSelectedPOI}
        viewType={viewType}
        redirectToDigitalTwin={redirectToDigitalTwin}
      /> */}

      {/* <Overlay padding={isOnCreateIncidentMode ? '0' : `${Theme.spacing["s07"]} ${Theme.spacing["s06"]}`}>
        {isOnCreateIncidentMode ? <CreateIncidentsOverlay close={() => { setMapClickCoordinates(null); setIsOnCreateIncidentMode(false) }}
          mapClickCoordinates={mapClickCoordinates} addNewIncidentToMap={addNewIncidentToMap} /> : null}

        {subEntity && !isOnCreateIncidentMode ? <WidgetsOverlay selectedPOI={selectedPOI} selectedLayer={selectedLayer} copyMapPois={copyMapPois}
          changeLayer={changeLayer} subEntity={subEntity} isToApplyFilters={isToApplyFilters}
          viewType={viewType} setViewType={(value) => setViewType(value)}
          selectedFloor={selectedFloor} setSelectedFloor={(value) => setSelectedFloor(value)} openClusterDrawer={() => { setSelectedCluster({ 'coordenates': copyMapPois }); showDrawer() }}
          setIsOnCreateIncidentMode={() => setIsOnCreateIncidentMode(true)} /> : null}
      </Overlay> */}

      {/* <MapCreateIncidentModal isCreateIncidentModalOpen={createIncidentModal} setCreateIncidentModal={setCreateIncidentModal}
        mapClickCoordinates={normalizeCoordinates(rigthClickCoordinates)}
        selectedPOI={rigthClickCoordinates?.poi}
      /> */}
    </PageContent>
  );
}

// const offStreeParkingCorrection = () => {
//   return 'Off Street Parking';
// }

//#region  Styled Components
const MapWrapper = styled.div`
  height: ${(props) => props.$marginTop ? "calc(100% - " + props.$marginTop + ")" : "100%"};
  margin-top: ${(props) => (props.$marginTop ? props.$marginTop : "0")};
  padding: 0;
  margin-left: ${(props) => (props.$marginLeft ? props.$marginLeft : "0")};
  width: -webkit-fill-available;
  position: absolute;
`;

const MapContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;

// Styling for the overlay
const Overlay = styled.div`
  padding: ${(props) => props.padding ? props.padding : null};
`;
//#endregion

const defaultMapConfigurations = {
  "heading": 0,
  "hide": [
    "attraction",
    "sports_complex",
    "place_of_worship",
    "business",
    "government",
    "medical",
    "park",
    "school"
  ],
  "mapId": "15fb961c1d0a757",
  "showGTFSRealTime": false,
  "showPOIS": true,
  "showTraffic": false,
  "showTransit": false,
  "showPolygon": false,
  "showEvents": false,
  "styles": "default",
  "tilt": 0,
  "zoom": 18,
  "lat": 38.73349368379715,
  "lng": -9.161331228834879,
  "hrefLink": "/home/register/registerDetail/",
  "poiType": "pois-color-by-family",
  "showLegend": false,
  "legendArray": [],
  "legendDetail": true,
  "hideEventsInfo": false,
  "circleRadius": null
}